import React from 'react';
import {BiTime} from "react-icons/bi";
import {GoLocation} from "react-icons/go";
import {ImSpoonKnife} from "react-icons/im"
import {AiFillCar,AiFillStar} from "react-icons/ai";
import {MdAddAPhoto} from "react-icons/md";
import {FiActivity} from "react-icons/fi";
export default function Page() {
  return (
    <div class="bg-black h-full">
    <div class="h-72 w-96 ml-auto mr-auto" style={{backgroundImage:"url('./images/Banner.jpg')",backgroundPosition:"center",backgroundSize:"cover"}}>
     <h1 class="text-white text-5xl text-center font-bold">Universal</h1>
     <h1 class="text-white text-5xl text-center font-bold">Adventures</h1>
     </div>
     <div class='w-96 ml-auto mr-auto bg-white' style={{height:1550}}>
     <div class="h-72  ml-auto mr-auto relative top-4 rounded-lg" style={{backgroundImage:"url('./images/Sky.jpg')",backgroundPosition:"center",backgroundSize:"cover",width:350}}>
         <h1 class="text-white text-3xl font-bold pt-60">Sky Diving</h1>
         </div>
         <div class="h-72 w-96 ml-auto mr-auto bg-white relative top-8 rounded-tl-lg rounded-tr-lg" style={{backgroundImage:"url('./images/Scuba.jpg')",backgroundPosition:"center",backgroundSize:"cover",width:350}}>
             <BiTime color="white" size={20} class="inline relative top-64"></BiTime><span class="text-white ml-2" style={{position:"relative",top:259}}>8 hour</span>
             <GoLocation color="white" size={20} class="relative left-40" style={{position:"relative",top:238}}></GoLocation><span class="text-white ml-48" style={{position:"relative",top:218}}>Goa, India</span>
             </div>
             <div class="border h-72  ml-auto mr-auto bg-white relative top-8" style={{width:350}}>
               <h1 class="text-xl font-bold ml-4 mt-2">Scuba Diving in Grande Island,Goa</h1>
             <div class="w-16 h-16 border bg-gray-300 ml-4 mt-2 float-left">
               <ImSpoonKnife size={30} class="ml-4 mt-2"></ImSpoonKnife>
               <p class="ml-2 text-sm">Snacks</p>
             </div>
             <div class="w-16 h-16 border bg-gray-300 ml-1 mt-2 float-left">
               <AiFillCar size={30} class="ml-4 mt-2"></AiFillCar>
               <p class=" text-sm">Transport</p>
             </div>
             <div class="w-20 h-16 border bg-gray-300 ml-1 mt-2 float-left">
               <MdAddAPhoto size={30} class="ml-4 mt-2"></MdAddAPhoto>
               <p class="text-sm">photo/video</p>
             </div>
             <div class="w-16 h-16 border bg-gray-300 ml-1 mt-2 float-left">
               <FiActivity size={30} class="ml-4 mt-2"></FiActivity>
               <p class=" text-sm">Activities</p>
             </div>
             <button class="border ml-2 mt-4 border-gray-500 rounded-3xl w-40 text-blue-300">Long tail boat ride</button>
             <button class="border ml-2 mt-4 border-black rounded-3xl w-48 text-blue-300">Underwater Photo &amp; Vide</button>
             <hr class="mt-6"></hr>
             <p class="text-gray-700 ml-4 relative top-2 inline">Starting from</p>
             <AiFillStar class="inline ml-20 mt-4" color="orange" size={24}></AiFillStar>
             <AiFillStar class="inline  mt-4" color="orange" size={24}></AiFillStar>
             <AiFillStar class="inline  mt-4" color="orange" size={24}></AiFillStar>
             <AiFillStar class="inline  mt-4" color="orange" size={24}></AiFillStar>
             <span class="border border-orange-300 bg-orange-300 rounded-md pl-2 pr-2 pt-1 text-white" style={{position:"relative",top:13}}>4.7</span><br></br>
             <h1 class="text-red-500 text-xl font-bold ml-4 inline">&#8377; 1799</h1>
             <p class="inline ml-40 text-gray-500">36 reviews</p>
             <button class="bg-green-500 rounded-br-xl rounded-bl-xl p-2 text-white font-bold" style={{width:350}}>View Details</button>
             </div>
             <div class="h-72 w-96 mt-4 bg-white ml-auto mr-auto rounded-tl-lg rouded-tr-lg relative top-16" style={{backgroundImage:"url('./images/Bungee.jpg')",backgroundPosition:"center",backgroundSize:"cover",width:350}}>
             <BiTime color="white" size={20} class="inline relative top-64"></BiTime><span class="text-white ml-2" style={{position:"relative",top:259}}>30 Min</span>
             <GoLocation color="white" size={20} class="relative left-40" style={{position:"relative",top:238}}></GoLocation><span class="text-white ml-48" style={{position:"relative",top:218}}>Goa, India</span>
             </div>
             <div class="border h-72  ml-auto mr-auto bg-white relative top-8" style={{width:350}}>
               <h1 class="text-xl font-bold ml-4 mt-2">Bungee Jumping in Goa</h1>
             
             <div class="w-20 h-16 border bg-gray-300 ml-4 mt-2 float-left">
               <MdAddAPhoto size={30} class="ml-4 mt-2"></MdAddAPhoto>
               <p class="text-sm">photo/video</p>
             </div>
             <div class="w-16 h-16 border bg-gray-300 ml-1 mt-2 float-left">
               <FiActivity size={30} class="ml-4 mt-2"></FiActivity>
               <p class=" text-sm">Activities</p>
             </div>
             <div class="clear-left"></div>
             <button class="border ml-2 mt-4 border-gray-500 rounded-3xl w-36  text-blue-300 inline">61 meters height</button>
             <button class="border ml-2 mt-4 border-black rounded-3xl w-44 text-blue-300">Jump Photo &amp; Video</button>
             <hr class="mt-6"></hr>
             <p class="text-gray-700 ml-4 relative top-2 inline">Starting from</p>
             <AiFillStar class="inline ml-20 mt-4" color="orange" size={24}></AiFillStar>
             <AiFillStar class="inline  mt-4" color="orange" size={24}></AiFillStar>
             <AiFillStar class="inline  mt-4" color="orange" size={24}></AiFillStar>
             <AiFillStar class="inline  mt-4" color="orange" size={24}></AiFillStar>
             <span class="border border-orange-300 bg-orange-300 rounded-md pl-2 pr-2 pt-1 text-white" style={{position:"relative",top:13}}>4.7</span><br></br>
             <h1 class="text-red-500 text-xl font-bold ml-4 inline">&#8377; 2800</h1>
             <p class="inline ml-40 text-gray-500">36 reviews</p>
             <button class="bg-green-500 rounded-br-xl rounded-bl-xl p-2 text-white font-bold" style={{width:350}}>View Details</button>
             </div>
            
             </div>
    </div>
  )
}
